/**
 * This file maps screen type names to their components, used in Wizard components.
 * See screenTypeSchema.js to see screen type definitions.
 */

import logJsUnexpected from '@zr/utilities/telemetry/logJsUnexpected';

import {
  COLLECT_EMAIL_ADDRESS,
  COLLECT_NAME_AND_PHONE_NUMBER,
  ELIGIBILITY_CELEBRATION,
  MOBILE_APP_NOTIFICATION_PROMO,
  MOBILE_APP_PRODUCT_PROMO,
  EMPLOYER_SCREENING_QUESTIONS,
  FINALIZE_APPLY,
  KEY_PROFILE_FIELDS,
  MERGE_PARSED_RESUME,
  MERGE_PARSED_RESUME_APPROVAL,
  PARTNER_REQUIRED_FIELDS,
  PERFORM_APPLY,
  PLATFORM_SUGGESTIONS,
  SET_PASSWORD,
  UPLOAD_RESUME_OR_CREATE_PROFILE,
} from './screenTypeSchema';

import CollectEmailAddress from './Screens/ScreenTypes/CollectEmailAddress/CollectEmailAddress';
import CollectNameAndPhoneNumber from './Screens/ScreenTypes/CollectNameAndPhoneNumber/CollectNameAndPhoneNumber';
import EligibilityCelebration from './Screens/ScreenTypes/EligibilityCelebration/EligibilityCelebration';
import MobileAppPromo from './Screens/ScreenTypes/MobileAppPromo/MobileAppPromo';
import EmployerScreeningQuestions from './Screens/ScreenTypes/EmployerScreeningQuestions/EmployerScreeningQuestions';
import FinalizeApply from './Screens/ScreenTypes/FinalizeApply/FinalizeApply';
import KeyProfileFields from './Screens/ScreenTypes/KeyProfileFields/KeyProfileFields';
import MergeParsedResume from './Screens/ScreenTypes/MergeParsedResume/MergeParsedResume';
import MergeParsedResumeApproval from './Screens/ScreenTypes/MergeParsedResumeApproval/MergeParsedResumeApproval';
import PartnerRequiredFields from './Screens/ScreenTypes/PartnerRequiredFields/PartnerRequiredFields';
import PerformApply from './Screens/ScreenTypes/PerformApply/PerformApply';
import PlatformSuggestions from './Screens/ScreenTypes/PlatformSuggestions/PlatformSuggestions';
import SetPassword from './Screens/ScreenTypes/SetPassword/SetPassword';
import UploadResumeOrCreateProfile from './Screens/ScreenTypes/UploadResumeOrCreateProfile/UploadResumeOrCreateProfile';

export const screenTypeMap = {
  [COLLECT_EMAIL_ADDRESS]: CollectEmailAddress,
  [COLLECT_NAME_AND_PHONE_NUMBER]: CollectNameAndPhoneNumber,
  [ELIGIBILITY_CELEBRATION]: EligibilityCelebration,
  [MOBILE_APP_NOTIFICATION_PROMO]: MobileAppPromo,
  [MOBILE_APP_PRODUCT_PROMO]: MobileAppPromo,
  [EMPLOYER_SCREENING_QUESTIONS]: EmployerScreeningQuestions,
  [FINALIZE_APPLY]: FinalizeApply,
  [KEY_PROFILE_FIELDS]: KeyProfileFields,
  [MERGE_PARSED_RESUME]: MergeParsedResume,
  [MERGE_PARSED_RESUME_APPROVAL]: MergeParsedResumeApproval,
  [PARTNER_REQUIRED_FIELDS]: PartnerRequiredFields,
  [PERFORM_APPLY]: PerformApply,
  [PLATFORM_SUGGESTIONS]: PlatformSuggestions,
  [SET_PASSWORD]: SetPassword,
  [UPLOAD_RESUME_OR_CREATE_PROFILE]: UploadResumeOrCreateProfile,
};

export function getScreenTypeComponent(screenType) {
  let ScreenTypeComponent = screenTypeMap[screenType];

  // this means we received a screen type that doesn't exist, log that this happened
  if (!ScreenTypeComponent) {
    ScreenTypeComponent = null;
    logJsUnexpected(`Invalid screen type received: ${screenType}`);
  }

  return ScreenTypeComponent;
}

export default screenTypeMap;
